import { createContext } from "react";

interface PageTitleContextType {
  title: string;
  subtitle: string;
  setPageTitle: (title: string, subtitle?: string) => void;
  clearPageTitle: () => void;
}

export const PageTitleContext = createContext<PageTitleContextType | undefined>(
  undefined,
);
